var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 7.5a3 3 0 1 0-2.861-2.096l-7.073 4.42a3 3 0 1 0 0 4.351l7.073 4.421a3 3 0 1 0 .796-1.272l-7.074-4.42a3 3 0 0 0 0-1.808l7.073-4.42A3 3 0 0 0 18 7.5M18 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m13.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgShare;